var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contents",staticClass:"contentStyle"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{on:{"window-open":_vm.windowOpen}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }